module.exports = __webpack_public_path__ + "img/02-02-img-03@2x.c967532b.png";